import { Owner } from "./Owner.model";
import { Company } from "./Company.model";

export class Project {
    _id: string;
    name: string;
    owner: Owner;
    company: Company = new Company();
    hashTrackId: string;
    hashTrackName: string;
    subDivision: number;
    projectExpense: Boolean = false;
    active: Boolean = true;

    loadFromServer(r: any) {

        if (r._id)
            this._id = r._id;

        if (r.name)
            this.name = r.name;

        if (r.hashTrackName)
            this.hashTrackName = r.hashTrackName;

        if (r.hashTrackId !== undefined)
            this.hashTrackId = r.hashTrackId;

        if (r.company !== undefined)
            this.company.loadToEdit(r.company);

        if (r.owner !== undefined)
            this.owner.loadOwnerFromServer(r.owner);

        if(r.subDivision !== undefined)
            this.subDivision = r.subDivision;

        if(r.active !== undefined)
            this.active = r.active;

        if(r.projectExpense)
            this.projectExpense = r.projectExpense;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Project.model.ts